import { Button, Col, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { FC } from 'react';
import { Ticket } from '../Raffles/interfaces';
import { BuyerData } from "../../interfaces/buyer";

interface PropsHomeModalInfo {
  open: boolean;
  onClose: Function;
  tickets: Ticket[];
  raffleName: string;
  buyerData: BuyerData;
  totalAmount: number;
}

const HomeModalInfo: FC<PropsHomeModalInfo> = ({ open, onClose, tickets = [], raffleName, buyerData, totalAmount }) => {
  const sendConfirmation = () => {
    const phoneNumber = "527718571117";
    const message = "Hola 👋 soy " + buyerData.buyer + ", acabo de apartar boletos para una rifa.\n\n" +
      "🎁 *Rifa:* " + raffleName + "\n" +
      "🎟️ *Boletos apartados:* " + tickets.map(t => t.number).join(", ") + "\n" +
      "💰 *Total a pagar:* $" + totalAmount + " MXN\n" +
      "📱 *Mi telefono:* " + buyerData.phone + "\n" +
      "📍 *Mi estado:* " + buyerData.state + "\n" +
      "⏳ *Vigencia del apartado:* 24 hrs";

    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <Modal
      open={open}
      cancelButtonProps={{
        hidden: true
      }}
      onOk={() => onClose()}
      okButtonProps={{
        hidden: true
      }}
      onCancel={() => onClose()}
      maskClosable={false}
    >
      <div style={{ fontWeight: "bold", fontSize: 18, textAlign: "center", paddingTop: 10 }}>
        <div style={{ color: "orangered", marginTop: 10 }}>
          Tus boletos permanecerán reservados por 24 horas. Si no se confirma el pago en este plazo, se liberarán automáticamente para su venta.
        </div>
        <div style={{ backgroundColor: "orangered", color: "white", padding: 10, borderRadius: 10, marginTop: 10 }}>
          TOMA CAPTURA DE ESTA PANTALLA Y ENVÍALO JUNTO CON TU COMPROBANTE DE PAGO AL CONFIRMAR EL PAGO O ENVIAR WHATSAPP AL 771 857 1117
        </div>
      </div>
      <br />
      <div style={{ textAlign: "center", fontSize: 18, fontWeight: "bold" }}>
        Boletos reservados:
      </div>
      <Row style={{ backgroundColor: "white" }} justify="center">
        {
          tickets.map((ticket: Ticket) => (
            <Col sm={4} key={ticket.id} style={{ padding: 5 }}>
              <div
                style={{
                  width: 60,
                  height: 30,
                  cursor: "pointer",
                  backgroundColor: ticket.status === "Libre" ? "green" : "red",
                  borderRadius: 30
                }}
              >
                <div style={{ paddingTop: 4, textAlign: "center", color: "white" }}>
                  {ticket.number.toString().padStart(6, "0")}
                </div>
              </div>
            </Col>
          ))
        }
      </Row>
      <Row
        justify="center"
      >
        <Button
          size="large"
          style={{
            backgroundColor: "green",
            color: "white",
            fontWeight: "bold",
            marginTop: 20,
            fontSize: 20,
          }}
          onClick={() => sendConfirmation()}
        >
          CONFIRMAR EL PAGO
        </Button>
      </Row>
    </Modal>
  );
};

export default HomeModalInfo;
